import request from "@/utils/request";
export function getUserSubList(data) {
    return request({
        url: "/user/subList",
        method: "GET",
        params: data
    });
}
export function addUser(data) {
    return request({
        url: "/user/addSub",
        method: "POST",
        data
    });
}
export function getUserInfo(data) {
    return request({
        url: "/user/detail",
        method: "GET",
        params: data
    });
}
export function deleteUser(data) {
    return request({
        url: "/user/delSub",
        method: "POST",
        data
    });
}
export function uploadAvatar(data) {
    return request({
        url: "/user/uploadAvatar",
        method: "POST",
        data
    });
}
export function getAvatar(data) {
    return request({
        url: "/user/genAvatar",
        method: "GET",
        params: data,
        responseType: "blob"
    });
}
export function getUserStorage(data) {
    return request({
        url: "/user/resource/host/storage",
        method: "GET",
        params: data
    });
}
export function openStorage(data) {
    return request({
        url: "/user/resource/host/storage/mount",
        method: "POST",
        data
    });
}
export function closeStorage(data) {
    return request({
        url: "/user/resource/host/storage/unmount",
        method: "POST",
        data
    });
}
export function updateStorage(data) {
    return request({
        url: "/user/resource/host/storage/mount",
        method: "PUT",
        data
    });
}
export function resetPassword(data) {
    return request({
        url: "/user/resetPassword",
        method: "POST",
        data
    });
}
